// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-buttons {
    display: flex;
    gap: 5px;
    justify-content: center;

    & > * {
        display: none;
    }

    & > .active-tab {
        display: block;
    }
}

.tab-buttons-height {
    height: 30px;
    width: auto;
    min-width: 100px;
    max-width: 160px;

    & > p {
        display: flex;
        gap: 3px;
        align-items: center;
        justify-content: center;
        margin-block-start: 10px;
        position: relative;
    }
}

.tab-content {
    /* Styles for the tab content container */
    display: flex;
    flex-direction: column;
}

.tab-pane {
    display: none;
    /* Other styles for tab content */
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out; /* Transition for opacity */
}

.tab-pane.active-tab-pane {
    display: block;
    /* Styles for the active tab content */
    transform: translateX(0);
}

@media (width < 480px) {
    .tab-buttons {
        flex-wrap: wrap;
    }
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/common-tabs-layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;;IAEvB;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;;IAEhB;QACI,aAAa;QACb,QAAQ;QACR,mBAAmB;QACnB,uBAAuB;QACvB,wBAAwB;QACxB,kBAAkB;IACtB;AACJ;;AAEA;IACI,yCAAyC;IACzC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,4BAA4B;IAC5B,sCAAsC,EAAE,2BAA2B;AACvE;;AAEA;IACI,cAAc;IACd,sCAAsC;IACtC,wBAAwB;AAC5B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".tab-buttons {\n    display: flex;\n    gap: 5px;\n    justify-content: center;\n\n    & > * {\n        display: none;\n    }\n\n    & > .active-tab {\n        display: block;\n    }\n}\n\n.tab-buttons-height {\n    height: 30px;\n    width: auto;\n    min-width: 100px;\n    max-width: 160px;\n\n    & > p {\n        display: flex;\n        gap: 3px;\n        align-items: center;\n        justify-content: center;\n        margin-block-start: 10px;\n        position: relative;\n    }\n}\n\n.tab-content {\n    /* Styles for the tab content container */\n    display: flex;\n    flex-direction: column;\n}\n\n.tab-pane {\n    display: none;\n    /* Other styles for tab content */\n    transform: translateX(-100%);\n    transition: transform 0.3s ease-in-out; /* Transition for opacity */\n}\n\n.tab-pane.active-tab-pane {\n    display: block;\n    /* Styles for the active tab content */\n    transform: translateX(0);\n}\n\n@media (width < 480px) {\n    .tab-buttons {\n        flex-wrap: wrap;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
